export default {
  routerObj: {
    path: '/supervisoryControl',
    component: () => import('@/views/routerView.vue'),
    name: '平台监控',
    children: [
      {
        path: '/supervisoryControl/supervisoryControlHome',
        component: () => import('@/views/supervisoryControl/supervisoryControlHome/index.vue'),
        name: '平台监控主页'
      },
      {
        path: '/supervisoryControl/dailyRecord',
        component: () => import('@/views/supervisoryControl/dailyRecord/index.vue'),
        name: '平台日志'
      },
      {
        path: '/terraceManage/authorizationLog',
        component: () => import('@/views/terraceManage/authorizationManage/authorizationLog.vue'),
        name: '授权时效日志'
      }
    ]
  }
}
